export class TimelineSliderClass {
    constructor(slider) {
        this.slider = slider;
        this.direction = document.querySelector('html').getAttribute('dir');
        this.overwriteDirection = document.querySelector('main').getAttribute('dir');

        if(this.overwriteDirection){
            this.sliderDirection = this.overwriteDirection;
        } else {
            this.sliderDirection = this.direction;
        }

        if (this.slider) {
            this.init();
        }
    }
    init() {
        let _this = this;
        // init and configure glide.js
        this.glide = new Glide(this.slider, {
            type: 'slider',
            gap: 20,
            perView: 18,
            bound: true,
            direction: _this.sliderDirection,
            breakpoints: {
                1300: {
                  perView: 12
                },
                768: {
                  perView: 6
                },
                500: {
                    perView: 4
                },
                400: {
                    perView: 3
                },
                350: {
                    perView: 2
                }
            },
            animationDuration: 500,
            classes: {
                direction: {
                    ltr: 'dir-ltr',
                    rtl: 'dir-rtl'
                },
                slider: 'is-slider',
                carousel: 'is-carousel',
                swipeable: 'is-swipeable',
                dragging: 'is-dragging',
                cloneSlide: 'is-clone',
                activeNav: 'is-active',
                activeSlide: 'is-active',
                disabledArrow: 'is-disabled'
            }
        });

        this.glide.mount();
    }
}

document.querySelectorAll('[data-timeline-slider]').forEach((item) => {
    new TimelineSliderClass(item);
});
